export default "__VITE_ASSET__36ttTjGH__"